import React from 'react';
import { useLocale } from '../i18n/LocaleProvider';

// served from frontend/public
const logo = '/lamptwist-logo.svg';

export default function Footer() {
  const { t } = useLocale();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 border-t border-sand/80">
      <div className="container flex flex-col items-start justify-between gap-4 py-10 sm:flex-row sm:items-center">
        <div>
          <img src={logo} alt="LampTwist" className="h-6 w-auto" />
          <p className="mt-2 text-sm text-muted-foreground">{t.footerTagline}</p>
        </div>
        <p className="font-num text-[11px] uppercase tracking-wider text-muted-foreground">
          © {year} LampTwist · {t.footerRights}
        </p>
      </div>
    </footer>
  );
}
